<template>
  <div id="contact-form">
    <form @submit.prevent="handleSubmit">
      <p>Formularz kontaktowy</p>

      <div v-if="isSend" id="ok-send">
        <span>Wiadomość wysłana pomyślnie!</span>
      </div>

      <div v-if="isError" id="error-send">
        <span>
          Błąd podczas wysyłania formularza, sprawdź dane!
          <span v-if="errContent"> : {{ errContent }}</span>
          <span v-if="!errContent">Jeżeli problem się powtarza, prosimy o kontakt</span>
        </span>
      </div>

        <label>
        <input
          type="text"
          name="phone"
          placeholder="Telefon"
          v-model="contact.phone">
      </label>
      <label>
        <input
          type="text"
          name="email"
          placeholder="Adres e-mail"
          v-model="contact.email">
      </label>
      <label>
        <textarea
          name="message"
          cols="30"
          rows="30"
          placeholder="Wiadomość"
          v-model="contact.message"
        ></textarea>
      </label>
      <button type="submit">Wyślij</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

const API = require('../../api').api_online;

export default {
  name: 'ContactForm',
  data() {
    return {
      contact: {
        phone: '',
        email: '',
        message: '',
      },
      isSend: false,
      isError: false,
      errContent: null,
    };
  },
  methods: {
    handleSubmit() {
      try {
        // eslint-disable-next-line no-throw-literal
        if (this.contact.phone === '') { throw 'Podaj Numer Telefonu!'; }
        // eslint-disable-next-line no-throw-literal
        if (this.contact.message === '') { throw 'Nie wysyłaj pustej wiadomości!'; }

        const formData = new FormData();
        formData.append('phone', this.contact.phone);
        formData.append('email', this.contact.email ? this.contact.email : "Nie podano email");
        formData.append('message', this.contact.message);

        axios.post(`${API}/new_request/index.php`, formData)
          .then(() => {
            this.isSend = true;
            this.isError = false;
          })
          .catch(() => {
            this.isSend = false;
            this.isError = true;
            this.errContent = null;
          });
      } catch (e) {
        this.isSend = false;
        this.isError = true;
        this.errContent = e;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  #contact-form {
    position: relative;
    padding: 25px;

    font-weight: bold;
    color: white;
    text-align: left;

    input, textarea, button {
      color: white;
      padding: 5px; margin: 5px 0;
      border-radius: 2px;

      /* for another font in FF */
      font-family: Quicksand, sans-serif;
      font-weight: bold;

      @media (min-width: 1200px) {
        font-weight: normal;
        font-size: 1em;
      }
    }

    input, textarea {
      width: 100%;
      border: none;
      background-color: #626262;

      &::placeholder {
        color: white;
      }
    }

    input { height: 20px; }
    textarea { height: 120px; resize: none }

    button {
      z-index: 5;
      position: relative;
      background-color: #00b32a;
      height: 30px; width: 200px;
      border: none;
      font-weight: bold;
      overflow: hidden;

      &::after {
        display: block; content: '';
        position: absolute;
        width: 100%; height: 100%;
        background-color: #00861e;
        top: 0;
        right: -100%;
        z-index: -1;
        transition: transform 200ms 50ms ease-in-out;
      }

      &:hover::after, &:active::after {
        transform: translateX(-100%);
      }
    }

    p { padding: 25px 25px 25px 0; }
    @media (min-width: 768px) {
      width: 60%; left: 20%;

      input { height: 30px; }
      textarea { height: 200px; }
      button { height: 40px; font-size: 1.3em }
    }

    @media (min-width: 992px) {
      p { padding: 0 0 25px 0; left: 0}
      grid-area: contact;
      width: 100%; left: 0;

      input { height: 40px; }
      textarea { height: 220px; }
      button { height: 50px; font-size: 1.5em }
    }
  }

  #ok-send, #error-send {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 2px;
    width: 100%;
    height: 50px;
    padding: 5px;

    font-size: 0.9em;
    text-align: center;
  }

  #ok-send { background-color: green; }
  #error-send { background-color: red; }
</style>
